import { HomeAgentic } from "./HomeAgentic";
import { HomeShieldCarousel } from "./HomeShieldCarousel";
import { HomeChannels } from "./HomeChannels";
import { HomeProductTrio } from "./HomeProductTrio";
import { HomeInfrastructureShowcase } from "./HomeInfrastructureShowcase";
import { BusinessSizesSection } from "./BusinessSizesSection";
import { InshurPlans } from "./InshurPlans";
import { InshurClaimCta } from "./InshurClaimCta";
/* Signature dark panel with rounded top corners, pulled up so it overlaps the
   hero photo. Kept explicitly dark in both colour schemes: it's a fixed brand
   surface, like the hero, not a themed page background. */
export function HomeShowcase({ cobrand = false } = {}) {
    return (<div className="relative z-10 -mt-16 rounded-t-[2.5rem] bg-[#0A0A0A] pb-24 pt-16 sm:-mt-20 sm:rounded-t-[3rem] sm:pt-20 lg:pb-32">
      <div className="flex flex-col gap-20 sm:gap-24 lg:gap-28">
        <div id="rent-direct" className="scroll-mt-24">
          <HomeChannels />
        </div>
        <div id="rent-shield" className="scroll-mt-24">
          {/* Owner (2026-10-01): the RentShield + INSHUR lockup on both pages; only the logo
              differs, so the home page keeps its links. */}
          <HomeShieldCarousel cobrand/>
          {cobrand ? <InshurClaimCta className="mt-10 px-5 sm:mt-12"/> : null}
        </div>
        <div id="rent-id" className="scroll-mt-24">
          <HomeAgentic />
          {cobrand ? <InshurClaimCta className="mt-10 px-5 sm:mt-12"/> : null}
        </div>
        <HomeProductTrio />
        {/* BusinessSizesSection uses light-theme tokens (dark text), so it must sit on a
            white surface — wrapped in a full-bleed white band to stay legible on the dark
            showcase panel, matching the adjacent white RentidEnterpriseSection. Rounded top
            corners let the dark section above curve down into the white band. */}
        <div className="rounded-t-[2.5rem] bg-white sm:rounded-t-[3rem]">
          <BusinessSizesSection />
        </div>
        {/* White layer behind the enterprise section so its rounded top corners reveal
            white (matching the BusinessSizesSection band above) instead of the dark panel.
            The negative margins live here so the white rectangle overlaps the gap cleanly. */}
        <div className="-mt-20 -mb-24 bg-white sm:-mt-24 lg:-mt-28 lg:-mb-32">
          <HomeInfrastructureShowcase />
          {/* Black backing so the plans section's rounded corners blend into the black
            enterprise section above rather than exposing the white layer. Owner (2026-10-01):
            pricing replaces "Build fast with rentid" on the home page; the INSHUR page keeps
            the promo variant. */}
          <div className="bg-black">
            <InshurPlans promo={cobrand} />
          </div>
        </div>
      </div>
    </div>);
}
